export default "__VITE_ASSET__CAvf2VY2__"